import { render, staticRenderFns } from "./calendar-schedule-card.vue?vue&type=template&id=4edd583e&scoped=true"
import script from "./calendar-schedule-card.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar-schedule-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./calendar-schedule-card.vue?vue&type=style&index=0&id=4edd583e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd583e",
  null
  
)

export default component.exports